import { Analytics } from './Analytics/Analytics';

export class AARPInternalAPI {
    static initRightRail(updateAds: boolean) {
        try {
            const AARP: any = (window as any).AARP;

            Analytics.trackEvent(
                Analytics.general.displayAd(updateAds)
            );

            if (updateAds) {
                AARP.ads.refreshAdsBySlot();
            }

            if (AARP.Everywhere.MembershipTout && AARP.Everywhere.MembershipTout.setUpInContext) {
                AARP.Everywhere.MembershipTout.setUpInContext();
            }

            if (AARP.Foundation.AdaptImages && AARP.Foundation.AdaptImages.adapt) {
                AARP.Foundation.AdaptImages.adapt();
            }

            if (AARP.Foundation.LazyLoad && AARP.Foundation.LazyLoad.load) {
                AARP.Foundation.LazyLoad.load();
            }
        } catch (e) {
            // swallow for now, then send to ai
        }
    }

    static destoryAdsSlots(container: Element) {
        (window as any).googletag.cmd.push(() => {
            const slots = (window as any).googletag.pubads().getSlots();
            slots.forEach(slot => {
                const id = slot.getSlotElementId();
                const el = container.querySelector(`#${id}`);
                if (el) {
                    (window as any).googletag.destroySlots([slot]);
                }
            });
        });
    }
}
